export default __webpack_public_path__ + "static/media/underconstruction.c8c8bbb6.png";